import { render, staticRenderFns } from "./MHouse.vue?vue&type=template&id=c2c01894&scoped=true&"
import script from "./MHouse.vue?vue&type=script&lang=js&"
export * from "./MHouse.vue?vue&type=script&lang=js&"
import style0 from "./MHouse.vue?vue&type=style&index=0&id=c2c01894&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c01894",
  null
  
)

export default component.exports